import { ReactElement } from 'react';
import { Link, makeStyles, Typography } from '@material-ui/core';
import WarningOutlined from '@material-ui/icons/WarningOutlined';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { FontFamily } from '@principal-developer-portal/ui';

const WARNING_ORANGE = '#F57C00';

const useStyles = makeStyles(theme => ({
  notice: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '12px 16px',
    border: `1px solid ${WARNING_ORANGE}`,
    borderLeft: `8px solid ${WARNING_ORANGE}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    fontSize: 40,
    color: WARNING_ORANGE,
  },
  title: {
    fontFamily: FontFamily.Bold,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
  },
  body: {
    fontFamily: FontFamily.Regular,
    fontSize: '16px',
    lineHeight: '24px',
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '8px',
    fontFamily: FontFamily.Bold,
    fontWeight: 700,
  },
}));

export interface PotentialDuplicateNoticeProps {
  /** The link is omitted until there is a page to point it at. */
  learnMoreHref?: string;
}

export const PotentialDuplicateNotice = ({
  learnMoreHref,
}: PotentialDuplicateNoticeProps): ReactElement => {
  const classes = useStyles();

  return (
    <div className={classes.notice} data-testid="potential-duplicate-notice">
      <WarningOutlined className={classes.icon} />
      <div>
        <Typography variant="h3" className={classes.title}>
          Possible duplicate finding
        </Typography>
        <Typography className={classes.body}>
          This finding may have already been reported as a zero-day issue.
          Please review existing findings before continuing.
        </Typography>
        {learnMoreHref && (
          <Link
            href={learnMoreHref}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            Learn more about potential duplicate findings
            <ArrowForward fontSize="small" />
          </Link>
        )}
      </div>
    </div>
  );
};
